import React from "react";
import { ClientDetailsAndDocumentStep } from "../../../components/ClientDetailsAndDocumentStep";

type Props = { lockArena?: boolean };

export const VendorClientDetailsAndInvoiceStep: React.FC<Props> = ({ lockArena }) => {
  return <ClientDetailsAndDocumentStep documentType={"invoice"} lockArena={lockArena} />;
};

export default VendorClientDetailsAndInvoiceStep;
